import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { withSnackbar } from "notistack";
import React from "react";
import { FormattedMessage } from "react-intl";
import Select from "react-select";
import { instance } from "../../../../Actions/AxiosInstance";
import {
  ValidateAction,
  ValidateList,
  ValidateReqField,
  ValidateReqFields,
  ValidateSearchDropdown,
} from "../../../../Utils/Validation";
import { CustomForm } from "../../../../Assets/Js/CustomForm";
import createstore from "../../../../store";

class EmpAddressForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // addresstypeid: this.props.addresstypeid,
      addressTypeName: "",
      data: this.props.data,
      fields: {
        addressline1: "",
        addressline2: "",
        pincode: "",
      },
      reqFields: {
        addressline1: "",
      },
      list: {
        countryid: "",
        stateid: "",
        cityid: "",
        addresstypeid: this.props.addresstypeid,
      },
      reqList: {
        addresstypeid: "",
        countryid: "",
        stateid: "",
        cityid: "",
      },
      errors: {},
      helperText: {},
      country: [],
      placeholder: "text",
      selectedCountry: { displayname: "Select Country", displayvalue: "" },
      stateprovince: [],
      selectedState: { displayname: "Select State", displayvalue: "" },
      cityzone: [],
      selectedCity: { displayname: "Select City", displayvalue: "" },
      AllAddress: [],
      addressType: [],
      selectedAddressType: {
        displayname: "Select Address Type",
        displayvalue: "",
      },
      b_addressType: [],
    };
  }

  componentDidMount() {
    // CustomForm();
    setTimeout(() => this.GetPerticularAddress(), 1000);
    if (this.firstElement) this.firstElement.focus();
  }

  componentWillMount() {
    // this.props.ChangeLanguage("");
    this.getCountry();
    this.getAddressType();
    const { SubscriptionInfo } = createstore.getState();
    const { accountid } = SubscriptionInfo.SubscriptionData;
    const { subscriptionid } = SubscriptionInfo.SubscriptionData;
    const { countrytimezoneid } = SubscriptionInfo.SubscriptionData;
    const { employeeid } = SubscriptionInfo.SubscriptionData;
    this.setState(
      {
        accountid,
        subscriptionid,
        countrytimezoneid,
        employeeid,
      },
      () => {},
    );
  }

  getCountry() {
    instance
      .get("superuser/allcountry")
      .then((result) => {
        const country = [];
        country.push(
          { displayname: "Select Country", displayvalue: "" },
          ...result.data.result,
        );
        this.setState({ country });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  getState() {
    const data = this.state.data || {};
    if (this.state.list.countryid) {
      const URL = `superuser/statebycountryid/${this.state.list.countryid}`;
      instance
        .get(URL)
        .then((result) => {
          const stateprovince = [];
          stateprovince.push(
            { displayname: "Select State", displayvalue: "" },
            ...result.data.result,
          );
          this.setState({ stateprovince }, () => {
            // this.setState({ selectedState: this.state.stateprovince.find(x => x.displayvalue == data.stateid) })
          });
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    } else {
      let cityzone;
      const stateprovince = [
        {
          displayname: "Select State",
          displayvalue: "",
        },
      ];
      cityzone = [
        {
          displayname: "Select City",
          displayvalue: "",
        },
      ];
      this.setState({ stateprovince, cityzone }, () => {
        // this.setState({ selectedState: this.state.stateprovince.find(x => x.displayvalue == data.stateid) })
      });
    }
  }

  getCity() {
    const data = this.state.data || {};
    if (this.state.list.stateid && this.state.list.countryid) {
      const URL = `superuser/citybystateid/${this.state.list.stateid}`;
      instance
        .get(URL)
        .then((result) => {
          const cityzone = [];
          cityzone.push(
            { displayname: "Select City", displayvalue: "" },
            ...result.data.result,
          );
          this.setState({ cityzone }, () => {
            // this.setState({ selectedCity: this.state.cityzone.find(x => x.displayvalue == data.cityid) })
          });
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    } else {
      let cityzone;
      cityzone = [
        {
          displayname: "Select City",
          displayvalue: "",
        },
      ];
      this.setState({ cityzone }, () => {
        // this.setState({ selectedCity: this.state.cityzone.find(x => x.displayvalue == data.cityid) })
      });
    }
  }

  getAddressType() {
    instance
      .get("superuser/getmastercode/HomeAddressType")
      .then((result) => {
        const addressType = [];
        addressType.push(
          { displayname: "Select Address Type", displayvalue: "" },
          ...result.data.result,
        );
        this.setState({
          b_addressType: addressType,
        });
        const { AllAddress, data } = this.props;
        const presentadd =
          AllAddress &&
          AllAddress.find((address) => address.addresstypeid == 1);
        const peradd =
          AllAddress &&
          AllAddress.find((address) => address.addresstypeid == 2);
        let filteraddreses = [];
        if (peradd && presentadd) {
          if (data && data.addresstypeid) {
            filteraddreses =
              addressType &&
              addressType.filter(
                (address) =>
                  address.displayvalue == data.addresstypeid ||
                  address.displayvalue == 3,
              );
          } else {
            filteraddreses =
              addressType &&
              addressType.filter(
                (address) =>
                  address.displayvalue != 1 && address.displayvalue != 2,
              );
          }
          this.setState({
            addressType: filteraddreses,
          });
        } else if (peradd && !presentadd) {
          if (data && data.addresstypeid) {
            this.setState({
              addressType,
            });
          } else {
            filteraddreses =
              addressType &&
              addressType.filter((address) => address.displayvalue != 2);
            this.setState({
              addressType: filteraddreses,
            });
          }
        } else if (!peradd && presentadd) {
          if (data && data.addresstypeid) {
            this.setState({
              addressType,
            });
          } else {
            filteraddreses =
              addressType &&
              addressType.filter((address) => address.displayvalue != 1);
            this.setState({
              addressType: filteraddreses,
            });
          }
        } else {
          this.setState({
            addressType,
          });
        }
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  GetPerticularAddress() {
    if (this.state.data) {
      const { data } = this.state;
      const { addressid } = data;
      const { employeeaddressid } = data;
      const fields = {
        addressline1: data.addressline1,
        addressline2: data.addressline2,
        pincode: data.pincode,
      };
      const reqFields = {
        addressline1: data.addressline1 ? data.addressline1 : "",
        pincode: data.pincode ? data.pincode : "",
      };
      const list = {
        countryid: data.countryid,
        stateid: data.stateid,
        cityid: data.cityid,
        addresstypeid: data.addresstypeid,
      };
      const reqList = {
        countryid: data.countryid ? data.countryid : "",
        stateid: data.stateid ? data.stateid : "",
        cityid: data.cityid ? data.cityid : "",
        addresstypeid: data.addresstypeid ? data.addresstypeid : "",
      };
      const selectedCountry = this.state.country.find(
        (x) => x.displayvalue == list.countryid,
      );
      const selectedAddressType = this.state.b_addressType.find(
        (x) => x.displayvalue == list.addresstypeid,
      );
      let addressTypeName = "";
      for (const type of this.state.addressType) {
        if (type.displayvalue == list.addresstypeid) {
          addressTypeName = type.displayname;
        }
      }
      this.setState({
        addressTypeName,
        fields,
        selectedAddressType,
        reqFields,
        list,
        reqList,
        selectedCountry,
        employeeaddressid,
        addressid,
      });
      if (list.countryid) {
        this.getState();
        setTimeout(
          () =>
            this.setState({
              selectedState: this.state.stateprovince.find(
                (x) => x.displayvalue == list.stateid,
              ),
            }),
          300,
        );
      }
      if (list.stateid) {
        this.getCity();
        setTimeout(
          () =>
            this.setState({
              selectedCity: this.state.cityzone.find(
                (x) => x.displayvalue == list.cityid,
              ),
            }),
          300,
        );
      }
    }
  }

  Validate() {
    let formIsValid = true;

    if (!ValidateReqFields(this.state)) {
      formIsValid = false;
    }
    if (!ValidateList(this.state)) {
      formIsValid = false;
    }
    return formIsValid;
  }

  UpdateAddress() {
    let value;
    this.state.list.addresstypeid == 1 && !this.state.employeeaddressid
      ? (value = 2)
      : (value = 4);

    if (!this.Validate()) {
      this.props.enqueueSnackbar("Please fill all the required fields", {
        variant: "error",
      });
    } else {
      const data = {
        addressid: this.state.addressid ? this.state.addressid : null,
        employeeaddressid: this.state.employeeaddressid
          ? this.state.employeeaddressid
          : null,
        addressline1: this.state.fields.addressline1,
        addressline2: this.state.fields.addressline2
          ? this.state.fields.addressline2
          : undefined,
        pincode: this.state.fields.pincode
          ? this.state.fields.pincode
          : undefined,
        countryid: this.state.list.countryid,
        stateid: this.state.list.stateid,
        cityid: this.state.list.cityid,
        addresstypeid: this.state.list.addresstypeid,
        employeeid: this.props.colleagueid || this.state.employeeid,
        // addresstypeid: 1
      };
      if (!createstore.getState().AuthenticationAction.IsFulfilled) {
        Object.assign(data, {
          accountid: this.state.accountid,
          subscriptionid: this.state.subscriptionid,
          timezoneid: this.state.countrytimezoneid,
        });
      }
      this.setState({ data });
      instance
        .post("employee/insertupdateempaddress", data)
        .then((result) => {
          this.setState({
            employeeaddressid: "",
            addressline1: "",
            addressline2: "",
            pincode: "",
            countryid: "",
            stateid: "",
            cityid: "",
            addresstypeid: "",
            addressid: "",
          });

          this.props.enqueueSnackbar("Saved successfully", {
            variant: "success",
          });

          this.props.GetAddr(
            value,
            result.data.result.employeeaddressid,
            this.state.data,
            true,
          );
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    }
  }

  BackLink = () => {
    this.props.BackLink();
  };

  OnFieldChange(field, type, e) {
    const { fields } = this.state;
    fields[field] = e.target.value ? e.target.value : "";
    this.setState({ fields });
    ValidateAction(this.state, field, type);
  }

  ValidateField(reqField, type, e) {
    const { reqFields } = this.state;
    reqFields[reqField] = e.target.value ? e.target.value : "";
    this.setState({ reqFields });
    if (ValidateAction(this.state, reqField, type)) {
      ValidateReqField(this.state, reqField, type);
    }
  }

  UpdateSelectedDropdownItem(name, HtField, selectedItem) {
    const { list } = this.state;
    const { reqList } = this.state;
    list[name] = selectedItem.displayvalue ? selectedItem.displayvalue : "";
    reqList[name] = selectedItem.displayvalue ? selectedItem.displayvalue : "";
    let selectedState;
    let selectedCity;
    this.setState({ list });
    if (name === "countryid") {
      Object.assign(this.state.list, { stateid: "", cityid: "" });
      Object.assign(this.state.reqList, { stateid: "", cityid: "" });
      selectedState = {
        displayname: "Select state",
        displayvalue: "",
      };
      selectedCity = {
        displayname: "Select city",
        displayvalue: "",
      };
      this.setState(
        {
          list,
          reqList,
          selectedState,
          selectedCity,
          selectedCountry: selectedItem,
        },
        () => {
          this.getState();
          this.getCity();
        },
      );
    }
    if (name === "stateid") {
      Object.assign(this.state.list, { cityid: "" });
      Object.assign(this.state.reqList, { cityid: "" });
      selectedCity = {
        displayname: "Select city",
        displayvalue: "",
      };
      this.setState(
        {
          list,
          reqList,
          selectedState: selectedItem,
          selectedCity,
        },
        () => {
          this.getCity();
        },
      );
    }
    if (name === "cityid") {
      this.setState({ list, reqList, selectedCity: selectedItem });
    }

    if (name === "addresstypeid") {
      this.setState({ list, reqList, selectedAddressType: selectedItem });
    }

    this.ValidateEachDropDown(name);
    // if (reqList[name] == '' || reqList[name]) {
    //     reqList[name] = selectedItem.displayvalue ? selectedItem.displayvalue : '';
    //     this.setState({ reqList }, () => {
    //         this.ValidateEachDropDown(name);
    //     });
    // }
  }

  ValidateOnNext(reqField, type) {
    if (ValidateAction(this.state, reqField, type)) {
      ValidateReqField(this.state, reqField, type);
    }
  }

  ValidateEachDropDown(name) {
    ValidateSearchDropdown(this.state, name).then((result) => {
      this.setState({
        errors: result.errors,
      });
    });
  }

  render() {
    const { classes, theme } = this.props;
    const { value } = this.state;

    return (
      <div className="emp-from-wrapper imp-dates">
        <div className="form-height">
          <div id="div">
            <div>
              {this.state.addresstypeid == 1 ? (
                <p className="input-form-label address-label">
                  {" "}
                  <FormattedMessage
                    id="Lbpermanentaddresstitle"
                    defaultMessage="Hey, we would love to know your permanent address"
                  />
                </p>
              ) : (
                ""
              )}
            </div>
            <div>
              {this.state.addresstypeid == 2 ? (
                <p className="input-form-label address-label">
                  {" "}
                  <FormattedMessage
                    id="Lbpresentaddresstitle"
                    defaultMessage="Hey, we would love to know your present address"
                  />
                </p>
              ) : (
                ""
              )}
            </div>
            <div>
              {this.state.addresstypeid == 5 ? (
                <p className="input-form-label address-label">
                  {" "}
                  <FormattedMessage
                    id="Lbotheraddresstitle"
                    defaultMessage="Great, kindly provide your other address"
                  />
                </p>
              ) : (
                ""
              )}
            </div>

            <form
              className="custom-form-box profile-address"
              autoComplete="off"
            >
              <div className="inner-wrapper opaque" tabIndex="0" autoFocus>
                <div className="form-group">
                  <p className="input-form-label">
                    {" "}
                    <FormattedMessage
                      id="LbAddressType"
                      defaultMessage="Address Type"
                    />{" "}
                  </p>
                  <Select
                    className="selectsearch Present-Address"
                    ref={(r) => {
                      this.firstElement = r;
                    }}
                    onChange={this.UpdateSelectedDropdownItem.bind(
                      this,
                      "addresstypeid",
                      "HtAddressType",
                    )}
                    options={this.state.addressType}
                    getOptionLabel={(option) => option.displayname}
                    getOptionValue={(option) => option.displayvalue}
                    value={this.state.selectedAddressType}
                    // isDisabled={this.state.employeeaddressid}
                    placeholder="Address Type"
                  />

                  <div>
                    {this.state.errors.addresstypeid ? (
                      <span className="caption-error">
                        <FormattedMessage
                          id="ErAddressType"
                          defaultMessage="please select address type"
                        />{" "}
                      </span>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
              <div className="inner-wrapper opaque" tabIndex="1">
                <div className="form-group">
                  <p className="input-form-label">
                    <FormattedMessage
                      id="LbAddressLineOne"
                      defaultMessage="Address Line One"
                    />
                  </p>
                  <TextField
                    id="outlined-dense"
                    className="Address1"
                    margin="dense"
                    variant="outlined"
                    placeholder="Address line one"
                    onChange={this.OnFieldChange.bind(
                      this,
                      "addressline1",
                      "text",
                    )}
                    onBlur={this.ValidateField.bind(
                      this,
                      "addressline1",
                      "text",
                    )}
                    value={this.state.fields.addressline1}
                    maxLength="100"
                  />

                  {/* <input type="text" className="form-control" id="addressline1" placeholder="Address line one"
                                        onChange={this.OnFieldChange.bind(this, "addressline1", "text")}
                                        onBlur={this.ValidateField.bind(this, "addressline1", "text")}
                                        value={this.state.fields.addressline1}
                                        maxLength="100" /> */}
                  <div>
                    {this.state.errors.addressline1 ? (
                      <span className="caption-error">
                        {" "}
                        <FormattedMessage
                          id="ErAddressLineOne"
                          defaultMessage="can not be empty"
                        />
                      </span>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
              <div className="inner-wrapper opaque" tabIndex="2">
                <div className="form-group">
                  <p className="input-form-label">
                    <FormattedMessage
                      id="LbAddressLineTwo"
                      defaultMessage="Address Line Two"
                    />{" "}
                    <FormattedMessage
                      id="LbOptional"
                      defaultMessage="(Optional)"
                    />
                  </p>
                  <div>
                    <TextField
                      id="outlined-dense"
                      margin="dense"
                      variant="outlined"
                      placeholder="Address line two"
                      onChange={this.OnFieldChange.bind(
                        this,
                        "addressline2",
                        "text",
                      )}
                      value={this.state.fields.addressline2}
                      maxLength="100"
                    />
                  </div>
                </div>
              </div>
              <div className="inner-wrapper opaque" tabIndex="3">
                <div className="form-group">
                  <p className="input-form-label">
                    {" "}
                    <FormattedMessage
                      id="LbCountry"
                      defaultMessage="Country"
                    />{" "}
                  </p>
                  <Select
                    className="selectsearch Country"
                    onChange={this.UpdateSelectedDropdownItem.bind(
                      this,
                      "countryid",
                      "HtCountry",
                    )}
                    options={this.state.country}
                    getOptionLabel={(option) => option.displayname}
                    getOptionValue={(option) => option.displayvalue}
                    value={this.state.selectedCountry}
                    placeholder="Select Country"
                    // selected={(option)=>option.displayvalue == props.Selected}
                  />
                  <div>
                    {this.state.errors.countryid ? (
                      <span className="caption-error">
                        <FormattedMessage
                          id="ErCountry"
                          defaultMessage="please select country"
                        />{" "}
                      </span>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
              <div className="inner-wrapper opaque" tabIndex="4">
                <div className="form-group">
                  <p className="input-form-label">
                    {" "}
                    <FormattedMessage
                      id="LbState/Province"
                      defaultMessage="State/Province"
                    />{" "}
                  </p>

                  <Select
                    className="selectsearch State"
                    onChange={this.UpdateSelectedDropdownItem.bind(
                      this,
                      "stateid",
                      "HtState/Province",
                    )}
                    options={this.state.stateprovince}
                    getOptionLabel={(option) => option.displayname}
                    getOptionValue={(option) => option.displayvalue}
                    value={this.state.selectedState}
                    placeholder="Select State"
                    // selected={(option)=>option.displayvalue == props.Selected}
                  />
                  <div>
                    {this.state.errors.stateid ? (
                      <span className="caption-error">
                        <FormattedMessage
                          id="ErState/Province"
                          defaultMessage="please select state"
                        />{" "}
                      </span>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
              <div className="inner-wrapper opaque" tabIndex="5">
                <div className="form-group">
                  <p className="input-form-label">
                    {" "}
                    <FormattedMessage
                      id="LbCity/Zone"
                      defaultMessage="Select city"
                    />{" "}
                  </p>
                  {/* <SelectDropDown
                                    data={this.state.cityzone}
                                    Selected={this.state.list.cityid}
                                    onSelected={this.UpdateSelectedDropdownItem.bind(this, "cityid")} /> */}
                  <Select
                    className="selectsearch City"
                    onChange={this.UpdateSelectedDropdownItem.bind(
                      this,
                      "cityid",
                      "HtCity/Zone",
                    )}
                    options={this.state.cityzone}
                    getOptionLabel={(option) => option.displayname}
                    getOptionValue={(option) => option.displayvalue}
                    value={this.state.selectedCity}
                    placeholder="Select City"
                    // selected={(option)=>option.displayvalue == props.Selected}
                  />
                  <div>
                    {this.state.errors.cityid ? (
                      <span className="caption-error">
                        <FormattedMessage
                          id="ErCity"
                          defaultMessage="please select city"
                        />{" "}
                      </span>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
              <div className="inner-wrapper opaque" tabIndex="6">
                <div className="form-group">
                  <p className="input-form-label">
                    {" "}
                    <FormattedMessage
                      id="LbPostalCode"
                      defaultMessage="Postal Code"
                    />{" "}
                  </p>
                  <div>
                    {/* <input type="text" className="form-control" id="pincode" placeholder="pincode/zipcode"
                                            onChange={this.OnFieldChange.bind(this, "pincode", "text")}
                                            onBlur={this.ValidateField.bind(this, "pincode", "text")}
                                            value={this.state.fields.pincode}
                                            maxLength="20" /> */}
                    <TextField
                      className="pincode"
                      margin="dense"
                      variant="outlined"
                      id="pincode"
                      placeholder="pincode/zipcode"
                      onChange={this.OnFieldChange.bind(
                        this,
                        "pincode",
                        "text",
                      )}
                      onBlur={this.ValidateField.bind(this, "pincode", "text")}
                      value={this.state.fields.pincode}
                      maxLength="20"
                    />
                  </div>
                  <div>
                    {this.state.errors.pincode ? (
                      <span className="caption-error">
                        <FormattedMessage
                          id="ErPostalCode"
                          defaultMessage="please enter postal code"
                        />{" "}
                      </span>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
              <div className="upform-footer">
                {/* <div className="form-btn form-control" onClick={this.UpdateAddress.bind(this)}><FormattedMessage
                                id="BtSubmit"
                                defaultMessage="SAVE"
                            /> </div> */}
                <div>
                  <div className="inlineClass">
                    <Button
                      variant="contained"
                      className="form-btn form-control save"
                      size="large"
                      color="primary"
                      onClick={this.UpdateAddress.bind(this)}
                    >
                      <FormattedMessage id="BtSave" defaultMessage="Save" />
                    </Button>
                  </div>
                  <div className="inlineClass margin-left-16">
                    <Button
                      className="Cancel"
                      size="large"
                      onClick={this.BackLink.bind(this)}
                    >
                      <FormattedMessage id="BtCancel" defaultMessage="Cancel" />
                    </Button>
                  </div>
                </div>
              </div>
              {/* <span className="caption-error">{this.state.CommonError}</span> */}
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default withSnackbar(EmpAddressForm);
